import { AuditTypesEnum } from "./IAudit";

export interface IValidatedTransactionDate {
    transactionDateError?: TransactionDateError;
    lastAuditedOn?: Date;
    newValidTransactionDate?: Date;
    newTransactionDateAvailableQty?: number;
    auditType?: AuditTypesEnum;
    packageNdc?: string;
}

export enum TransactionDateError {
    none = 0,
    transactionDateBeyondLastAudit,
    negativeBalance,
    amendBeforeOriginalTransaction,
    movedToOlderThanMovedFrom,
    movedFromYoungerThanMovedTo
}